import { ChangeDetectionStrategy, Component, computed, inject, input, model, OnInit, output, signal, viewChild } from '@angular/core';
import { ProfileService } from '@mwe/services';
import { FeatureToggleEnum } from '@mwe/constants';
import { IOlavEntry } from '@mwe/models';
import { AddressSearchComponent } from '../address-search/address-search.component';
import { AddressInputComponent } from '../address-input/address-input.component';

@Component({
  selector: 'mwe-address-search-wrapper',
  imports: [AddressSearchComponent, AddressInputComponent],
  templateUrl: './address-search-wrapper.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressSearchWrapperComponent implements OnInit {
  readonly predefinedOlavKey = input<string>('');
  readonly ignoreAvailableZipCodes = input<boolean>(false);
  readonly selectedOlav = model<IOlavEntry | null>(null);
  readonly processType = input<string>(null);

  readonly addressInputCompleted = output<boolean>();
  readonly errorStateEvent = output<boolean>();
  readonly noResultsFound = output<boolean>();

  private readonly profileService = inject(ProfileService);

  readonly newAddressSearch = viewChild(AddressSearchComponent);
  readonly oldAddressSearch = viewChild(AddressInputComponent);

  isNewAddressSearchEnabled = signal(false);

  readonly activeFormManualEntry = computed(() =>
    this.isNewAddressSearchEnabled()
      ? this.newAddressSearch().selection()
      : this.oldAddressSearch().getSelectedOlavWithLatestUserInputForManualAddressInput(),
  );

  ngOnInit() {
    this.isNewAddressSearchEnabled.set(this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.NEW_ADDRESS_SEARCH_ENABLED));
  }

  onSelectOlav(olavEntry: IOlavEntry) {
    this.selectedOlav.set(olavEntry);
  }

  onValidAddressSet(value: boolean) {
    this.addressInputCompleted.emit(value);
  }

  onErrorState(value: boolean) {
    this.errorStateEvent.emit(value);
  }

  validate() {
    if (this.isNewAddressSearchEnabled()) {
      return this.newAddressSearch()?.validate();
    }
    return this.oldAddressSearch()?.validate();
  }
}
